import PrimaryButton from "Components/atoms/buttons/primary-button"
import SecondaryButton from "Components/atoms/buttons/secondary-button"
import SearchFormContainer from "Components/atoms/containers/search-form-container"
import ToFromInput from "Components/molecule/inputs/to-from-input"
import { SelectOption } from "Components/molecule/inputs/select-input"
import MultiSelect from "Components/molecule/inputs/multi-select"
import { IConsultingIncomeQuery } from "models/consulting-income"
import useEnterSearch from "hooks/useEnterSearch"

interface SearchConsultingIncomeFormProps {
    query: IConsultingIncomeQuery
    fiscalPeriodOptions: SelectOption[]
    branchOptions: SelectOption[]
    isSearching: boolean
    handleChangeQuery: (key: string, value: any) => void
    handleSearch: () => void
    handleClearSearch: () => void
}

const SearchConsultingIncomeForm = ({
    query,
    fiscalPeriodOptions,
    branchOptions,
    isSearching,
    handleChangeQuery,
    handleSearch,
    handleClearSearch,
}: SearchConsultingIncomeFormProps) => {
    const { selectProps } = useEnterSearch(handleSearch)

    return (
        <SearchFormContainer
            inputs={
                <>
                    <MultiSelect
                        className="col-md-6"
                        label="Branch"
                        options={branchOptions}
                        value={branchOptions.filter(o => query.branchIds?.includes(String(o.value)))}
                        onChange={(v: SelectOption[]) => handleChangeQuery('branchIds', v.map(o => String(o.value)))}
                        placeholder="Select branches"
                    />
                    <ToFromInput
                        className="col-md-6 mw-100"
                        fromFiscalPeriod={query.fromFiscalPeriod!}
                        toFiscalPeriod={query.toFiscalPeriod!}
                        handleChangeFrom={(val) => handleChangeQuery('fromFiscalPeriod', val)}
                        handleChangeTo={(val) => handleChangeQuery('toFiscalPeriod', val)}
                        fiscalPeriodOptions={fiscalPeriodOptions}
                        {...selectProps}
                    />
                </>
            }
            clearSearchButton={
                <>
                    <PrimaryButton
                        style={{ minWidth: '150px' }}
                        disabled={isSearching}
                        onClick={handleSearch}
                    >
                        {isSearching ? 'Searching...' : 'Search'}
                    </PrimaryButton>
                    <SecondaryButton
                        style={{ minWidth: '100px' }}
                        disabled={isSearching}
                        onClick={handleClearSearch}
                    >
                        Clear Search
                    </SecondaryButton>
                </>
            }
        />
    )
}

export default SearchConsultingIncomeForm
